import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteReportsSlice = createSlice({
    name: "deleteReportsRequest",
    initialState,
    reducers: {
        deleteReportsRequest(state) {
            state.loading = true;
        },
        deleteReportsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteReportsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteReportsStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteReportsRequest,
    deleteReportsRequestSuccess,
    deleteReportsRequestError,
    deleteReportsStateReset,
} = DeleteReportsSlice.actions;

export default DeleteReportsSlice.reducer;
